import React, { memo, useContext } from 'react';
import { MainLayoutContext } from '../../layouts/MainLayout';
import logo from './../../images/LogoGray.svg';
import cls from './footer.module.css';
import { classNames } from 'lib/classNames';

const Footer = () => {
  const { setIsOpen } = useContext(MainLayoutContext);
  const year = String(new Date().getFullYear())

  return (
    <footer className={cls.footer}>
      <div className='line' />
      <div className={cls.footer_wrapper}>
        <section className={cls.footer_grid}>
          <img src={logo} className={cls.logo} alt='Примпиво' />
          <div
            className={classNames('', {}, [
              [cls['footer_grid_item']],
              [cls['number_phone']],
            ])}
          >
            <span>Номер телефона: </span>
            <a className={cls.a_footer_grid} href='tel:+7(914)705-76-99'>
              +7(914)705-76-99
            </a>
          </div>
          <div
            className={classNames('', {}, [
              [cls['footer_grid_item']],
              [cls['adress']],
            ])}
          >
            Адрес: Приморский край, <br />
            г. Владивосток, Снеговая ул., д. 34
          </div>
          <button
            onClick={() =>
              setIsOpen((prev) => {
                return { ...prev, policy: true };
              })
            }
            className={classNames('', {}, [
              [cls['button_footer_grid']],
              [cls['footer_grid_item']],
              [cls['policy']],
            ])}
          >
            Политика конфедециальности
            <br /> и Условия использования
          </button>
          <div
            className={classNames('', {}, [
              [cls['footer_grid_item']],
              [cls['email']],
            ])}
          >
            <span>Почта: </span>
            <a className={cls.a_footer_grid} href='mailto:office@primpivo.ru'>
              office@primpivo.ru
            </a>
          </div>
        </section>
      </div>
      <p className={cls.oferta_footer}>
        Информация на сайте расположена в ознакомительных целях и не является
        публичной офертой
      </p>
      <div className={cls.copy}>© ООО «Примпиво», 2022-{year}</div>
    </footer>
  );
};

export default memo(Footer);
